<template>
  <span>{{ getClientTier(customer.client_tier) }}</span>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('global');

export default {
  name: "ClientTierDisplayWidget",
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({clientTierOptions: state => state.clientTierOptions,})
  },
  methods: {
    getClientTier(tier) {
      if (!this.clientTierOptions || !this.clientTierOptions.length) {
        return tier;
      }
      for (let i in this.clientTierOptions) {
        if (this.clientTierOptions[i].id === tier) {
          return this.clientTierOptions[i].text;
        }
      }
      return tier;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
